module.exports = __webpack_public_path__ + "static/images/hb5.3350a6f.jpg";